import Vue from 'vue';
import { Button, Form, FormItem, Input, Pagination, Dialog, Loading } from 'element-ui';
import { InputNumber, Message, MessageBox, Notification, DropdownMenu } from 'element-ui';
import { Breadcrumb, BreadcrumbItem, Dropdown, DropdownItem, Tabs, TabPane } from 'element-ui';
import { Checkbox, CheckboxButton, CheckboxGroup, Switch, Cascader } from 'element-ui';
import { Select, Option, Radio, Carousel, CarouselItem, Card, Upload } from 'element-ui';
import { DatePicker } from 'element-ui';

Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Button);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Pagination);
Vue.use(Switch);
Vue.use(TabPane);
Vue.use(Tabs);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Card);
Vue.use(Upload);
Vue.use(DatePicker);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
